import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 退料 create payload（camel → snake）。
 * 不送 returnNo（後端產生）；不送 sourceQty（approve 時由後端決定）。
 * Line 可選 unitId（有值才帶）。
 */
export function serializeStockReturnCreate(values) {
  const {
    returnNo: _ignoredNo,
    sourceQty: _ignoredSourceQty,
    ...rest
  } = values ?? {};

  const payload = { ...rest };
  if ('lines' in rest) {
    payload.lines = mapReturnLines(rest.lines, { allowUnitId: true });
  }

  return keysToSnake(payload);
}

/**
 * 退料 update payload（camel → snake）。
 * 含 updatedAt 樂觀鎖；不送 returnNo／sourceQty。
 * Line 可選 unitId（有值才帶）。
 */
export function serializeStockReturnUpdate(values) {
  const {
    returnNo: _ignoredNo,
    sourceQty: _ignoredSourceQty,
    ...rest
  } = values ?? {};

  const payload = { ...rest };
  if ('lines' in rest) {
    payload.lines = mapReturnLines(rest.lines, { allowUnitId: true });
  }

  return keysToSnake(payload);
}

/**
 * 退料異動單 create／update payload（camel → snake）。
 * lines 同樣不送 sourceQty；**永不**送 unitId（amendment 無 selector）。
 */
export function serializeStockReturnAmendmentWrite(values) {
  const rest = values ?? {};
  const payload = { ...rest };
  if ('lines' in rest) {
    payload.lines = mapReturnLines(rest.lines, { allowUnitId: false });
  }
  return keysToSnake(payload);
}

/**
 * @param {array} lines
 * @param {{ allowUnitId?: boolean }} [options]
 */
export function mapReturnLines(lines = [], { allowUnitId = false } = {}) {
  return (lines ?? []).map((line) => {
    const {
      sourceQty: _ignoredSourceQty,
      returnNo: _ignoredNo,
      ...rest
    } = line ?? {};
    // 來源二擇一：待分配送 pendingAllocationId，否則送 invStockId。
    const mapped = rest.pendingAllocationId
      ? { pendingAllocationId: rest.pendingAllocationId }
      : { invStockId: rest.invStockId };
    mapped.returnedQty = rest.returnedQty;
    mapped.remark = rest.remark ?? null;

    if (allowUnitId) {
      const unitId = String(rest.unitId ?? '').trim();
      if (unitId) {
        mapped.unitId = unitId;
      }
    }

    return mapped;
  });
}
